import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "./useAuth";

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { status, login } = useAuth();
  const location = useLocation();
  const [loginError, setLoginError] = useState<Error | null>(null);

  const needsAuth = status === "unauthenticated";

  useEffect(() => {
    if (!needsAuth) return;
    let cancelled = false;
    void (async () => {
      try {
        await login(location.pathname + location.search);
      } catch (err) {
        if (import.meta.env.DEV) {
          console.warn("[oidc] login redirect failed", err);
        }
        if (!cancelled) {
          setLoginError(err instanceof Error ? err : new Error(String(err)));
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [needsAuth, login, location.pathname, location.search]);

  if (status === "initializing") {
    return <div className="tawa-app loading">Chargement…</div>;
  }

  if (needsAuth) {
    if (loginError) {
      return (
        <div className="tawa-app loading">
          <p>Connexion à Keycloak indisponible. Veuillez réessayer.</p>
          <button
            onClick={() => void login(location.pathname + location.search)}
          >
            Réessayer
          </button>
        </div>
      );
    }
    return <div className="tawa-app loading">Redirection vers Keycloak…</div>;
  }

  return <>{children}</>;
}
